import styled from '@emotion/styled';
import React from 'react';
import { Icon, Popup } from 'semantic-ui-react';
import { Label } from './Label';
import { OptionButtons } from './OptionButtons';
import { OptionDropdown } from './OptionDropdown';

const Wrapper = styled.div`
	min-width: 400px;
	width: 400px;
	max-width: 400px;
	height: 30px;
	display: flex;
`;

const QuestionMark = styled(Icon)`
	display: inline-block !important;
	vertical-align: middle !important;
	margin-left: 8px !important;
`;

interface DisabledOptionValue {
	type: 'value',
	disabledReason: string;
	values: (string | boolean | number)[];
}

interface DisabledOption {
	type: 'option',
	disabledReason: string;
}

export type Disabled = DisabledOption | DisabledOptionValue;

interface OptionProps {
	optionKey: string;
	optionValues: readonly (string | boolean | number)[];
	onChange: (value: string | boolean | number | null) => void;
	disabled?: Disabled;
	selectedValue: string | boolean | number | null;
}

export const Option: React.FC<OptionProps> = ({ optionKey, optionValues, onChange, disabled, selectedValue }) => (
	<Wrapper>
		<Label>{optionKey}</Label>
		{optionValues.length <= 5 ? (
			<OptionButtons options={optionValues} onChange={onChange} disabled={disabled} {...(selectedValue && { defaultValue: selectedValue.toString() })} />
		) : (
			<OptionDropdown
				disabled={disabled?.type === 'option'}
				onChange={onChange}
				options={optionValues}
				optionKey={optionKey}
				selectedValue={selectedValue} />
		)}
		{(disabled?.type === 'option' || disabled?.type === 'value') && (
			<Popup
				key={optionKey}
				trigger={<span>
					<QuestionMark name="question circle outline" />
				</span>}
				content={disabled.disabledReason} />
		)}
	</Wrapper>
);
